import React, { useEffect, useState } from "react";
import { ConfigItem } from "./ConfigItem";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Col,
  Row,
  FormGroup,
  Form,
  Input,
  Button,
  Modal,
} from "react-bootstrap";
//import Radio from 'components/atoms/@vuexy/radio/RadioVuexy'
//import Checkbox from 'components/atoms/@vuexy/checkbox/CheckboxesVuexy'
import { Checkbox, Radio, FormControlLabel } from "@mui/material";
//import { Check, Minus, Search, Save } from 'react-feather'
import FeatherIcon from "feather-icons-react";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import GroupsIcon from "@mui/icons-material/Groups";
import Select, { components } from "react-select";
import Icon from "./Icon";
import PermissionGroup from "components/Modal/PermissionGroup";
import FolderMenu from "components/Modal/FolderMenu";
import httpClient from "utility/httpClient.util";
import {
  REPORT_RESOURCE_OUTPUT_FIELDS,
  isReportResourceOutput,
  setReportResourceOutput,
} from "./reportResource.util";
import {
  REPORT_OUTPUT_MODE_OPTIONS,
  applyReportOutputMode,
  getReportOutputMode,
  isPrintStyleOutputMode,
} from "./reportOutputMode.util";
const { Option } = components;
export const IconOption = (props) => (
  <Option {...props}>
    {props.data.iconName && <Icon name={props.data.iconName} />}
    {props.data?.flag  && <span style={{ fontSize: 20 }}>{props.data?.flag}</span>}
    <span style={{ marginLeft: "5px" }}>{props.data.label}</span>
  </Option>
);

export const CustomSingleValue = ({ data }) => (
  <div className="input-select">
    <div className="input-select__single-value">
      <Icon name={data.iconName} />
      {data?.flag  && <span style={{ fontSize: 20 }}>{data?.flag}</span>}
      <span style={{ marginLeft: "5px" }}>{data.label}</span>
    </div>
  </div>
);

const SIZE_OPTIONS = [
  { label: "IPD", value: "IPD" },
  { label: "OPD", value: "OPD" },
  { label: "Custom", value: "Custom" },
];

const getSelectedOptions = (options = [], values = []) => {
  const selectedValues = (Array.isArray(values) ? values : [values])
    .filter((value) => value !== null && value !== undefined && value !== "")
    .map((value) => String(value));

  return options.filter((option) => selectedValues.includes(String(option.value)));
};

const normalizeHexColor = (value) => {
  const color = String(value || "").trim();
  return /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(color)
    ? color
    : "";
};

const getContrastTextColor = (hexColor) => {
  const color = normalizeHexColor(hexColor).replace("#", "");
  if (!color) return "#495057";
  const rgb = color.length === 3
    ? color.split("").map((item) => parseInt(item + item, 16))
    : [color.slice(0, 2), color.slice(2, 4), color.slice(4, 6)].map((item) => parseInt(item, 16));
  const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;

  return luminance > 0.6 ? "#17202a" : "#fff";
};

const getReportTagBadgeColors = (tag = {}) => {
  const color = normalizeHexColor(tag.hexColor);

  return {
    backgroundColor: color || "#e9ecef",
    borderColor: color || "#ced4da",
    color: color ? getContrastTextColor(color) : "#495057",
  };
};

const getReportTagSelectStyles = () => ({
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  multiValue: (base, state) => {
    const colors = getReportTagBadgeColors(state.data);
    return {
      ...base,
      backgroundColor: colors.backgroundColor,
      border: "1px solid " + colors.borderColor,
      borderRadius: "4px",
    };
  },
  multiValueLabel: (base, state) => {
    const colors = getReportTagBadgeColors(state.data);
    return {
      ...base,
      color: colors.color,
      fontWeight: 500,
    };
  },
  multiValueRemove: (base, state) => {
    const colors = getReportTagBadgeColors(state.data);
    const hasColor = Boolean(normalizeHexColor(state.data?.hexColor));
    return {
      ...base,
      color: colors.color,
      ":hover": {
        backgroundColor: hasColor ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.08)",
        color: colors.color,
      },
    };
  },
});

const ReportTagOption = (props) => {
  const colors = getReportTagBadgeColors(props.data);

  return (
    <Option {...props}>
      <span
        style={{
          display: "inline-block",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          backgroundColor: colors.backgroundColor,
          border: "1px solid " + colors.borderColor,
          borderRadius: "4px",
          color: colors.color,
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "18px",
          padding: "1px 6px",
        }}
        title={props.data.description || props.data.label}
      >
        {props.data.label}
      </span>
    </Option>
  );
};

const PublishMenu = (props) => {
  const [show, setShow] = useState(false);
  const [rootFolder, setRootFolder] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const menu = [
    { name: "Text" },
    { name: "Image" },
    { name: "Date" },
    { name: "Checkbox" },
    { name: "Barcode" },
    { name: "Qrcode" },
    { name: "Table" },
    { name: "Report" },
  ];
  //const [state,setState] = useState(Object.assign({moduleName:'',publishAt:"",locationCode:"",printStyle:false,exportExcel:false},props.publish))
  const state = props.publish;
  const {
    savePermission,
    permissionsDefault,
    handleClosePermission,
    showModalPermission,
    handleShowPermission,
  } = props;
  console.log("publishMenu", state);

  const [folderName, setFolderName] = useState("");

  const updateData = async (field, value,e,parentKey=null) => {

    let newState = {};
    if(parentKey){  
      newState = { ...props.publish }    
      if(!newState[parentKey]){
        newState[parentKey] = {}
      }
      newState[parentKey][field] = value
    }else{
      newState = { ...props.publish, [field]: value };
    }
    if (field == "moduleName") {
      newState.locationCode = null;
    }
    setState(newState);
  };

  const publishAtChange = () => {
    let newValue = props.publish.publishAt == "report" ? "print" : "report";

    setState({ ...props.publish, ["publishAt"]: newValue });
  };

  const toggleCheckbox = (field) => {
    if (
      isReportResourceOutput(props.publish) &&
      REPORT_RESOURCE_OUTPUT_FIELDS.includes(field)
    ) {
      return;
    }

    let newValue = !props.publish[field];

    setState({ ...props.publish, [field]: newValue });
  };

  const setOutputMode = (outputMode) => {
    setState(applyReportOutputMode(props.publish, outputMode));
  };

  const toggleResourceOutput = () => {
    const enabled = !isReportResourceOutput(props.publish);
    if (enabled) {
      setFolderActive(false);
      setShow(false);
    }

    setState(
      setReportResourceOutput(
        props.publish,
        enabled
      )
    );
  };

  const setState = (newState) => {
    if (props.onChange) {
      props.onChange(newState);
    }
  };

  const onSave = () => {
    if (props.onSave) {
      props.onSave(props.publish);
      handleClose();
    }
  };

  const [folderActive, setFolderActive] = useState(false);

  const getFolderId = (folder) => {
    setFolderName(folder.text);
    setState({ ...props.publish, folderId: folder.id });
  };

  const handleClose = () => {
    setShow(false);
  };

  const onSelectFolder = () => {
    const newValue = !folderActive;
    setFolderActive(newValue);
    if (!newValue) {
      const { folderId, ...rest } = props.publish;
      setState({ ...rest });
    }
  };

  const getRootFolder = async () => {
    await httpClient.get("/document/folder/list-root").then((res) => {
      if (res.status === 200) {
        const rootItems = res.data.data.map((item) => {
          return {
            label: item.name,
            value: item.name,
            rootFolderId: item.folderId,
          };
        });
        setRootFolder(rootItems);
      }
    });
  };
  const [folderCode, setFolderCode] = useState("");

  const handleChange = (event) => {
    console.log(event.value);
    setFolderCode(event.value);
  };

  const renderInput = (title, field,parentKey=null) => {
    return (
      <FormGroup row>
        <Form.Label for="value" className="text-sm-right">
          {title}
        </Form.Label>
        <Form.Control
          type="text"
          name="value"
          value={parentKey?(props.publish[parentKey][field] || ''):props.publish[field]}
          onChange={(e) => updateData(field, e.target.value,e,parentKey)}
        />
      </FormGroup>
    );
  };



  const renderSelect = (title, field, options, disabled = false,isClearable=false) => {
    let item = options.find((e) => e.value === props.publish[field]);
    const state = props.publish;
    return (
      <FormGroup row>
        <div>{title}</div>
        <div style={{ width: "100%" }}>
          <Select
            name={field}
            isDisabled={disabled}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            // maxMenuHeight={options.length > 0 ? 48 * options.length : 48}
            options={options}
            value={
              state[field] &&
              Object.assign(
                {
                  label: state[field],
                  value: state[field],
                },
                item ? item : {}
              )
            }
            onChange={async (e) => {
              await updateData(field, e?.value, e);
            }}
            components={{ Option: IconOption, SingleValue: CustomSingleValue }}
            isClearable={isClearable}    
          ></Select>
        </div>
      </FormGroup>
    );
  };

  const renderCategorySelect = (title, options, disabled = false) => {
    const categoryIds = Array.isArray(props.publish.categoryIds)
      ? props.publish.categoryIds
      : props.publish.categoryId
      ? [props.publish.categoryId]
      : [];
    const selectedOptions = getSelectedOptions(options, categoryIds);

    return (
      <FormGroup row>
        <div>{title}</div>
        <div style={{ width: "100%" }}>
          <Select
            name="categoryIds"
            isMulti
            isClearable
            closeMenuOnSelect={false}
            isDisabled={disabled}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
            menuPortalTarget={document.body}
            options={options}
            value={selectedOptions}
            onChange={(items) => {
              const selectedItems = Array.isArray(items) ? items : [];
              const selectedCategoryIds = selectedItems
                .map((item) => item.value)
                .filter(
                  (value) => value !== null && value !== undefined && value !== ""
                );

              setState({
                ...props.publish,
                categoryIds: selectedCategoryIds,
                categoryId: selectedCategoryIds[0] || null,
                moduleName: selectedItems[0]?.label || props.publish.moduleName || "",
              });
            }}
            components={{ Option: IconOption }}
          ></Select>
        </div>
      </FormGroup>
    );
  };

  const renderTagSelect = (title, options = [], disabled = false) => {
    const tagIds = Array.isArray(props.publish.tagIds) ? props.publish.tagIds : [];
    const selectedOptions = getSelectedOptions(options, tagIds);

    return (
      <FormGroup row>
        <div>{title}</div>
        <div style={{ width: "100%" }}>
          <Select
            name="tagIds"
            isMulti
            isClearable
            closeMenuOnSelect={false}
            isDisabled={disabled}
            styles={getReportTagSelectStyles()}
            menuPortalTarget={document.body}
            options={options}
            value={selectedOptions}
            noOptionsMessage={() => 'ไม่มี Tag ในระบบ'}
            onChange={(items) => {
              const selectedItems = Array.isArray(items) ? items : [];
              const selectedTagIds = selectedItems
                .map((item) => Number(item.value))
                .filter((value) => Number.isFinite(value) && value > 0);
              const { newTags, ...publish } = props.publish;

              setState({
                ...publish,
                tagIds: selectedTagIds,
              });
            }}
            components={{ Option: ReportTagOption }}
          ></Select>
        </div>
      </FormGroup>
    );
  };

  const renderPrintAt = () => {
    return (
      props.publish.locationCode == "" && (
        <div>
          <FormGroup row>
            <Radio
              size="sm"
              color="primary"
              label="หน้ารายงาน"
              icon={<FeatherIcon size="12" icon="check" className="vx-icon" />}
              checked={props.publish.publishAt == "report"}
              onChange={(e) => publishAtChange()}
            />
          </FormGroup>
          <FormGroup row>
            <Radio
              size="sm"
              color="primary"
              label="หน้า Print"
              icon={<FeatherIcon size="12" icon="check" className="vx-icon" />}
              checked={props.publish.publishAt == "print"}
              onChange={(e) => publishAtChange()}
            />
          </FormGroup>
        </div>
      )
    );
  };

  const checkboxApprList = [{ value: "showBorder", label: "Show Border" }];
  const checkboxList = [
    { label: "Excel", value: "exportExcel" },
    { label: "Rotate on Print", value: "rotateOnPrint" },
    { label: "Auto Print", value: "autoPrint" },
  ];
  const resourceOutput = isReportResourceOutput(state);
  const outputMode = getReportOutputMode(state);

  useEffect(() => {
    getRootFolder();
  }, []);

  useEffect(() => {
    setFolderActive(
      !isReportResourceOutput(state) && "folderId" in state
    );
  }, [state]);

  return (
    <div>
      {renderCategorySelect(
        "แสดงใน Category",
        props.categoryList,
        props.publish.locationCode && props.publish.locationCode != ""
      )}
      {renderTagSelect("Tag", props.reportTagList || [])}
      {renderSelect(
        "Support Language",
        "languageSupport",
        props?.languageOption,
        false,
        true
      )}  
      
      {
        state?.languageSupport && 
          renderInput('Report Code ['+state?.languageSupport+']',state?.languageSupport,'langReportCode')
      }
      {renderSelect(
        "Tenant",
        "reportTenantCode",
        props.tenantList,
        props?.reportTenantCode
      )}
      <span>Appearance</span>
      {checkboxApprList.map(({ label, value }, index) => (
        <Col md={12}>
          <FormControlLabel
            control={
              <Checkbox
                size="small" // Use 'small' instead of 'sm'
                color="primary"
                checked={props.publish[value] || false}
                onChange={(e) => toggleCheckbox(value)} // Use 'value' directly
              />
            }
            label={label}
          />
        </Col>
      ))}
      <span>Output</span>
      <Col md={12}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={resourceOutput}
              onChange={toggleResourceOutput}
            />
          }
          label="Resource"
        />
      </Col>
      {!resourceOutput && (
        <div className="mb-1">
          <div className="small text-muted mb-1">Output mode</div>
          {REPORT_OUTPUT_MODE_OPTIONS.map(({ label, value }) => (
            <Col md={12} key={value}>
              <FormControlLabel
                control={
                  <Radio
                    size="small"
                    color="primary"
                    checked={outputMode === value}
                    onChange={() => setOutputMode(value)}
                  />
                }
                label={label}
              />
            </Col>
          ))}
        </div>
      )}
      {!resourceOutput &&
        checkboxList
          .filter(
            ({ value }) =>
              value !== "exportExcel" || isPrintStyleOutputMode(props.publish)
          )
          .map(({ label, value }) => (
            <Col md={12} key={value}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    checked={props.publish[value] || false}
                    onChange={() => toggleCheckbox(value)}
                  />
                }
                label={label}
              />
            </Col>
          ))}
      {!resourceOutput &&
        renderInput('Auto Print Delay (sec)','delayPrintSec')
      }

      {!resourceOutput && (
        <>
          <Col md={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={folderActive}
                  size="small"
                  color="primary"
                  onChange={onSelectFolder}
                />
              }
              label={"Save to Document"}
            />
          </Col>
          {folderActive === true && (
            <Col className="mb-2">
              {" "}
            select  <Button variant="light" onClick={() => setShow(true)}>
                {" "}
                <FolderCopyIcon style={{ color: "grey" }} />{" "}
              </Button>{" "}
              {folderName}
            </Col>
          )}
        </>
      )}

      <span>Permission</span>
      <Col md={12} className="mb-2 mt-2">
        <Button
          onClick={() => {
            handleShowPermission();
          }}
          variant="light"
        >
          <GroupsIcon
            style={{
              marginRight: "8px",

              color: permissionsDefault?.length > 0 ? "green" : "grey",
            }}
          />
          {permissionsDefault?.length > 0 &&
            permissionsDefault?.map((item, index, arr) => (
              <span key={index}>
                {item.name}
                {index < arr.length - 1 && ", "}
              </span>
            ))}
        </Button>
      </Col>

      <Button
        color="primary"
        outline
        style={{ width: "100%" }}
        onClick={() => onSave()}
      >
        <FeatherIcon size="16" icon="save" className="vx-icon" /> บันทึก
      </Button>
      <PermissionGroup
        permissionsDefault={permissionsDefault}
        savePermission={savePermission}
        show={showModalPermission}
        onHide={handleClosePermission}
      />
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Folder Document
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Select Root Folder</Form.Label>
              <Select
                value={rootFolder?.filter((obj) => obj?.value === folderCode)}
                className="w-100"
                placeholder="Select root Folder"
                onChange={handleChange}
                options={rootFolder}
              />
            </Form.Group>
          </Form>
          <FolderMenu codeFolder={folderCode} getFolderId={getFolderId} id={state?.folderId} />
        </Modal.Body>

        <Row className="p-3">
          <Col md={6} xs={6}>
            <Button variant="primary" onClick={() => onSave()}>
              <i className="fa fa-save"></i> บันทึก
            </Button>
          </Col>
          <Col md={6} xs={6}>
            <Button variant="danger" onClick={() => handleClose()}>
              <i className="fa fa-times"></i> ยกเลิก
            </Button>
          </Col>
        </Row>
      </Modal>
    </div>
  );
};

export default PublishMenu;
